var map = {
	"./ar.json": [
		2049,
		0
	],
	"./de.json": [
		2050,
		1
	],
	"./en.json": [
		605
	],
	"./es.json": [
		2051,
		2
	],
	"./fr.json": [
		2052,
		3
	],
	"./id.json": [
		2053,
		4
	],
	"./it.json": [
		2054,
		5
	],
	"./ja.json": [
		2055,
		6
	],
	"./no.json": [
		2056,
		7
	],
	"./pt-br.json": [
		2057,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1006;
module.exports = webpackAsyncContext;